"use strict";

const UserReportModal = {
  enableSubmitButton() {
    document.getElementById('submitButton').disabled = false;
  }
};

// ページロード後にグローバル定数にServicesFormを追加する
document.addEventListener("DOMContentLoaded", () => {
  Object.defineProperty(globalThis, "UserReportModal", {
    value: UserReportModal,
    writable: false,
  });
});
